var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoiToilets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#19456B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.0002H9.14286L11.7143 26.3336L14.5714 15.0002H17.4286L20.2857 26.3336L22.8571 15.0002H26L22.2857 32.0002H19.4286L16.2857 20.9652L13.1429 32.0002H10.2857L6 15.0002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9999 24.0979V23.1882C28.9999 18.3361 30.4892 15.0002 36.1488 15.0002C40.319 15.0002 42.4041 16.8198 42.9999 20.7621L39.4254 21.3686C39.4254 19.2458 38.5318 18.0328 36.1488 18.0328C33.1701 18.0328 32.2765 19.8523 32.2765 23.1882V24.0979C32.2765 27.737 33.1701 29.2533 36.1488 29.2533C38.5318 29.2533 39.1275 28.3435 39.4254 25.6142L42.9999 25.9175C42.4041 29.8598 40.6169 31.9826 35.8509 31.9826C30.7871 32.2858 28.9999 28.6468 28.9999 24.0979Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoiToilets);
export default __webpack_public_path__ + "static/media/poi-toilets.0cc2bed7818ebcc0913bb5458d67e0c2.svg";
export { ForwardRef as ReactComponent };